
import { defineComponent, ref, onMounted } from "vue"
import { useRouter } from "vue-router"
import dateTimeHelper from "../../helper/datetime.helper"
import { ApiService } from '../../services/backend-api/api.services'

export default defineComponent({
	components: {
	},
	setup() {
		const router = useRouter()
		let loading = ref(false)
		let errors = ref<string[]>([])
		let data = ref<any>({})
		let id = router.currentRoute.value.params.id
		onMounted(async () => {
			const apiService = new ApiService
			let previewData = await apiService.previewNotification(id)
			if (previewData.status) {
				data.value = previewData.data;

				//update view_count field
				await apiService.updateNoticeViewCount(id)
			} else {
				errors.value.push(previewData.data.message)
			}
			loading.value = false
		})

		return {
			errors,
			data,
			loading,
			dateTimeHelper,
		}
	}
});
